import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '../__root';

const oauthSearchSchema = z.object({
  token: z.string().optional(),
  error: z.string().optional(),
});

export const oauthCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/oauth-callback',
  validateSearch: oauthSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/auth/OAuthCallbackContent'),
    'OAuthCallbackContent',
  ),
});
